import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const authLink = setContext((_, { headers, accessToken }) => {
	return {
		headers: {
			...headers,
			...(accessToken ? { authorization: `Bearer ${accessToken}` } : {}),
		},
	};
});

const httpLink = createHttpLink({
	uri: `${process.env.GATSBY_GRAPHWEAVER_API_URL}`,
	headers: {
		'content-type': 'application/json',
		'apollo-require-preflight': 'true',
	},
});

export const apolloClient = new ApolloClient({
	cache: new InMemoryCache(),
	link: authLink.concat(httpLink),
});
